module.exports = __webpack_public_path__ + "static/img/home_page top img_mobile.55c398aa.jpg";